var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.533 3C9.347 3 3.5 8.847 3.5 16.034C3.5 23.221 9.347 29.067 16.533 29.067C23.719 29.067 29.566 23.22 29.566 16.034C29.566 8.848 23.72 3 16.533 3ZM16.533 27C10.486 27 5.567 22.08 5.567 16.033C5.567 9.986 10.486 5.066 16.533 5.066C22.58 5.066 27.5 9.986 27.5 16.034C27.5 22.081 22.58 27 16.533 27Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 9.66699V17.067H22.899V15H17.566V9.66699H15.5Z",
    fill: "#565656"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTime);
export default __webpack_public_path__ + "static/media/icon-time.716c65b5b0d74c64ab91b5b4ff3a2c98.svg";
export { ForwardRef as ReactComponent };